import { userUsesNewUiEligible } from '@utils/userUsesNewUiEligible'
import { agencyBillingRecoveryRedirect } from '@utils/agencyBillingRecoveryRedirect'
import {
  hasRepuAgencyAccess,
  isAgencySubscribed,
  isRepuagencyProductHost,
} from '@utils/subscription'

/**
 * Business users added via Settings → Add User are stored as role Team and must
 * impersonate into their assigned location to see the full business UI.
 * When they only have one team, skip the Locations picker and enter automatically.
 */
export async function redirectAfterLogin(store, router, user, { push } = {}) {
  const navigate = (location) => {
    if (typeof push === 'function') {
      return push(location)
    }
    return router.push(location)
  }

  if (!user) {
    return navigate({ name: 'login' })
  }

  if (user.role === 'Business') {
    const dash = userUsesNewUiEligible(user)
      ? 'new-business.dashboard'
      : 'business.dashboard'
    return navigate({ name: dash })
  }

  if (user.role === 'Team') {
    return enterTeamUserBusiness(store, navigate, user).then((result) => {
      if (result === false) {
        return navigate({ name: 'team.dashboard' })
      }
      return result
    })
  }

  if (user.role === 'Admin') {
    return navigate({ name: 'admin.agencies.index' })
  }

  if (user.role === 'Agency') {
    const onTrial = !!(user.on_trial || user.agency?.owner?.on_trial)
    if (
      isRepuagencyProductHost() &&
      !onTrial &&
      (agencyBillingRecoveryRedirect(user) ||
        (!hasRepuAgencyAccess(user) && !isAgencySubscribed(user)))
    ) {
      return navigate({ name: 'agency.subscription' })
    }
    if (isRepuagencyProductHost()) {
      return navigate({ name: 'agency.customers.index' })
    }
    return navigate({ name: 'agency.dashboard' })
  }

  return navigate('/' + String(user.role).toLocaleLowerCase())
}

export async function enterTeamUserBusiness(store, navigate, user) {
  const teams = Array.isArray(user?.teams) ? user.teams : []
  const singleTeam = teams.length === 1 ? teams[0] : null

  if (singleTeam?.id) {
    try {
      await store.dispatch('auth/impersonateTeam', singleTeam.id)
      await store.dispatch('auth/getProfile')
      const profile = store.getters['auth/user']
      const dash = userUsesNewUiEligible(profile)
        ? 'new-business.dashboard'
        : 'business.dashboard'
      return navigate({ name: dash })
    } catch (error) {
      console.error('Team auto-impersonation failed:', error)
      return false
    }
  }

  return navigate({ name: 'team.dashboard' })
}

export function businessDashboardRoute(user) {
  return userUsesNewUiEligible(user) ? 'new-business.dashboard' : 'business.dashboard'
}
